// tslint:disable:no-any

import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import Title from '../components/Title';
import DiveDataCards from '../components/DiveDataCards';
import { loadSharedDiveData } from '../actions/diveActions';
import Mixtures from '../components/DiveMixtures';
import EventsTable from '../components/DiveEvents';
import DiveComments from '../components/DiveComments';
import DiveCharts from '../components/DiveCharts';
import DiveModeInformation from '../components/DiveModeInformation';
import { DisplayDateTime } from '../components/Display';
import Loader from '../components/Loader';
import ErrorPage from '../components/ErrorPage';
import Dt from 'react-document-title';
import { NavigationStore } from './Navigation/NavigationStore';

export interface ISharedDiveProps {
    loadDiveData: any;
    dive: any;
    match: any;
}

interface ISharedDiveState {
    dive: any;
}

class SharedDive extends Component<ISharedDiveProps, ISharedDiveState> {
    constructor(props: ISharedDiveProps) {
        super(props);
        this.state = {
            dive: null
        };
    }

    componentWillReceiveProps(nextProps: ISharedDiveProps) {
        this.setState({
            dive: nextProps.dive
        });
    }

    componentDidMount() {
        // Navigation._setActive('dives', 'Shared dive detail');
        window.scrollTo(0, 0);
        this.props.loadDiveData(this.props.match.params.diveId);

        NavigationStore.getInstance().setActive('dives');
    }

    refreshDiveData() {
        this.props.loadDiveData(this.props.match.params.diveId);
    }

    scrollToComments() {
        window.scrollTo(
            0,
            document.body.scrollTop +
                ReactDOM.findDOMNode(this.refs.comments).getBoundingClientRect()
                    .top
        );
    }

    getTitle() {
        if (this.state.dive != undefined) {
            return `WetNotes | Shared dive #${
                this.state.dive.diveAndMixes.dive.serial
            } detail`;
        }

        return `WetNotes | Shared dive detail`;
    }

    render() {
        var dive = this.state.dive;

        if (dive === undefined || dive === null) {
            return <Loader />;
        }

        if (dive.errorText !== undefined) {
            return <ErrorPage />;
        }

        /*Navigation._setActive(
            'dives',
            `Shared dive #${dive.diveAndMixes.dive.serial} detail`
        );*/

        return (
            <Dt title={this.getTitle()}>
                <div className="dive">
                    <Title
                        heading={`Shared Dive #${dive.diveAndMixes.dive.serial}`}
                        breadcrumbs={[
                            {
                                caption: 'Shared Dives',
                                to: '/app/shared-dives'
                            },
                            {
                                caption: `Shared Dive #${
                                    dive.diveAndMixes.dive.serial
                                }`,
                                to: `/app/shared-dive/${
                                    dive.diveAndMixes.dive.id
                                }`
                            }
                        ]}
                    />

                    <div className="wrapper">
                        <div className="dive__chart">
                            {dive.diveAndMixes !== undefined && (
                                <div className="dive__chart__header">
                                    <h3>
                                        Dive #{dive.diveAndMixes.dive.serial},&nbsp;
                                        {dive.diveAndMixes.dive.location !==
                                        null
                                            ? dive.diveAndMixes.dive.location +
                                              ', '
                                            : ''}
                                        <DisplayDateTime
                                            data={
                                                dive.diveAndMixes.dive.startDate
                                            }
                                        />
                                    </h3>
                                    <div>
                                        <span
                                            className="dive__chart__header__icon--comment"
                                            onClick={() =>
                                                this.scrollToComments()
                                            }
                                        >
                                            Comments ({dive.comments.length})
                                        </span>
                                    </div>
                                </div>
                            )}

                            {this.state.dive.diveData !== undefined && (
                                <DiveCharts
                                    diveData={
                                        this.state.dive.diveData.graphData
                                    }
                                    diveEvents={this.state.dive.diveData.events}
                                />
                            )}
                        </div>

                        <DiveDataCards dive={dive} shared={true} />

                        <section>
                            {dive.diveAndMixes !== undefined && (
                                <DiveModeInformation dive={dive} />
                            )}

                            {dive.diveAndMixes !== undefined && (
                                <Mixtures data={dive.diveAndMixes.mixes} />
                            )}

                            {dive.diveData !== undefined && (
                                <EventsTable data={dive.diveData.events} />
                            )}
                        </section>

                        {dive.diveData !== undefined && (
                            <DiveComments
                                // tslint:disable-next-line:jsx-no-string-ref
                                ref="comments"
                                dive={dive}
                                // onRefreshDiveData={() => this.refreshDiveData()}
                            />
                        )}
                    </div>
                </div>
            </Dt>
        );
    }
}

const mapStateToProps = (state: any) => ({
    dive: state.dive || {}
});

const mapDispatchToProps = (dispatch: any) => ({
    loadDiveData: (diveId: any) => dispatch(loadSharedDiveData(diveId))
});

export default connect(mapStateToProps, mapDispatchToProps)(SharedDive);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SharedDive.tsx